import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class CommissionDiscountService {
  constructor(private http: HttpClientService) {}

  public post(commission_discount): Observable<any> {
    return this.http
      .post("/api/commission_discounts", commission_discount)
      .pipe(tap((_) => console.log("CommissionDiscountService.post: Ok.")));
  }

  public updateCommissionDiscount(id, data): Observable<any> {
    return this.http
      .put("/api/commission_discounts/" + id, data)
      .pipe(tap((_) => console.log("CommissionDiscountService.update: Ok.")));
  }

  public delete(id): Observable<any> {
    return this.http
      .delete("/api/commission_discounts/" + id)
      .pipe(tap((_) => console.log("CommissionDiscountService.delete: Ok.")));
  }
}
